/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

import type Form from '../../../../../../forms/_.extend';

type TypeProps = {
  costCenter: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class UnarchiveCostCenterForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { form }: TypeProps = this.props;
    const costCenter: Object = this.props.costCenter;

    const getChildData: Function = (child: string, val: string) => {
      return typeof costCenter[child] === 'undefined' ? null : costCenter[child][val];
    };

    const costCenterDetails: Array<Array> = [
      [t('general:trading_account'), getChildData('trading_account', 'name')],
      [t('general:cost_centers.labels.code'), costCenter.code],
      [t('general:cost_centers.labels.name'), costCenter.name],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:cost_centers.labels.details')}
          >
            <ActionDrawerTable data={costCenterDetails} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:cost_centers.reasons.why_unarchive')}
          >
            <div className={styles['form-group']}>
              <ElectroTextField
                field={form.$('unarchiveCostCenterForm.reason')}
                props={{
                  multiline: true,
                  rows: 3,
                }}
              />
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons
          form={form}
          submitTxt={t('general:actions.unarchive_cost_center')}
        />
      </React.Fragment>
    );
  }
}
